export const COLORS_GET_REQUEST = "@colors.get.request";
export const COLORS_GET_SUCCESS = "@colors.get.success";
export const COLORS_GET_FAIL = "@colors.get.failure";
